{
  "clear": "Izbriši",
  "invalid": "(nevažeće)",
  "loading": "Učitavam...",
  "noResults": "Nema rezultata",
  "valid": "(važeće)"
}
